module.exports = __webpack_public_path__ + "static/img/wireframe-low-fidelity.eda4055.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/online-acc-registration/wireframe-low-fidelity.gif
// module id = T5+m
// module chunks = 1